import { render, staticRenderFns } from "./AgentMerchantQrcode.vue?vue&type=template&id=132d3b1a&scoped=true&"
import script from "./AgentMerchantQrcode.vue?vue&type=script&lang=js&"
export * from "./AgentMerchantQrcode.vue?vue&type=script&lang=js&"
import style0 from "./AgentMerchantQrcode.vue?vue&type=style&index=0&id=132d3b1a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132d3b1a",
  null
  
)

export default component.exports